import {
  useEffect,
} from "react";

const DocumentTitle = ({ title }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return null;
};

export default DocumentTitle;
